import React, { useState, useEffect } from 'react';
import { Container, TextField, Button, MenuItem, Typography, Alert } from '@mui/material';
import contribuenteApi from '../../api/contribuenteApi';
import studioApi from '../../api/studioApi';
import { AuthContext } from '../../auth/AuthContext';
import { useContext } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import BackButtonDesktop from '../../components/BackButtonDesktop';

export default function ContribuenteEditPage() {
  const { id } = useParams();
  const [form, setForm] = useState(null);
  const [users, setUsers] = useState([]);
  const [err, setErr] = useState(null);
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);
  const isAdmin = user?.role === 'ADMIN';
  const isStudio = user?.role === 'STUDIO';

  useEffect(() => {
    contribuenteApi.get(id).then(r => setForm(r.data));
  }, [id]);

  useEffect(() => {
    if (isAdmin) {
      studioApi.list()
        .then(r => setUsers(r.data.content || []))
        .catch(e => setErr(extractErrorMessage(e)));
    }
  }, [isAdmin]);
  if (!form) return <div>Loading...</div>;
  console.log("form ",form);
  console.log("users ",users);
  const submit = async (e) => {
    e.preventDefault();
    try {
      await contribuenteApi.update(id, form);
      navigate(`/contribuenti/${id}`);
    } catch (e) {
      setErr(e.response?.data || e.message);
    }
  };


  return (
    <Container>
    <BackButtonDesktop />
      <Typography variant="h5">Modifica Contribuente</Typography>
      {err && <Alert severity="error">{String(err)}</Alert>}
      <form onSubmit={submit}>
        <TextField fullWidth sx={{ my: 1 }} label="Nome" required value={form.nome} onChange={e => setForm({...form, nome: e.target.value})} />
        <TextField fullWidth sx={{ my: 1 }} label="Cognome" required value={form.cognome} onChange={e => setForm({...form, cognome: e.target.value})} />
        <TextField fullWidth sx={{ my: 1 }} label="Codice Fiscale"
        inputProps={{
                maxLength: 16
        }}
        value={form.codiceFiscale} onChange={e => setForm({...form, codiceFiscale: e.target.value})} />
        <TextField fullWidth sx={{ my: 1 }} label="Partita IVA"
        required
        inputProps={{
                maxLength: 11,
                inputMode: "numeric",
                pattern: "[0-9]{11}"
        }}
         value={form.partitaIVA} onChange={e => setForm({...form, partitaIVA: e.target.value})} />
        <TextField select fullWidth sx={{ my: 1 }} label="Regime Fiscale"
          value={form.regimeFiscale}
          onChange={e => setForm({ ...form, regimeFiscale: e.target.value })}
        >
          {['ORDINARIO', 'FORFETTARIO', 'MINIMI', 'ALTRO']
            .map(r => <MenuItem key={r} value={r}>{r}</MenuItem>)}
        </TextField>
        <TextField fullWidth sx={{ my: 1 }} label="Email" required value={form.email} onChange={e => setForm({...form, email: e.target.value})} />
        <TextField fullWidth sx={{ my: 1 }} label="Telefono" value={form.telefono} onChange={e => setForm({...form, telefono: e.target.value})} />
        <TextField fullWidth sx={{ my: 1 }} label="Indirizzo" value={form.indirizzo} onChange={e => setForm({...form, indirizzo: e.target.value})} />
                {isAdmin && (
                  <TextField select fullWidth sx={{ my: 1 }}
                    label="Studio"
                    value={form.studioId}
                    onChange={e => setForm({ ...form, studioId: e.target.value })}
                    required
                  >
                    {users.map(u =>
                      <MenuItem key={u.utenteId} value={u.utenteId}>{u.ragionesociale}</MenuItem>
                    )}
                  </TextField>
                )}
        <Button variant="contained" type="submit">Salva</Button>
      </form>
    </Container>
  );
}